<script setup lang="ts">
  import { computed } from 'vue';
  import { SPINNER_SIZE_IN_PX } from './lib';
  import { SpinnerColor, SpinnerSize } from './Spinner.types';

  interface SpinnerProps {
    size?: `${SpinnerSize}`;
    color?: `${SpinnerColor}`;
  }

  const props = withDefaults(defineProps<SpinnerProps>(), {
    size: SpinnerSize.M,
    color: SpinnerColor.Primary,
  });

  const styles = computed(() => ({
    width: SPINNER_SIZE_IN_PX[props.size],
    height: SPINNER_SIZE_IN_PX[props.size],
  }));
</script>

<template>
  <div :style="styles">
    <svg
      :class="['tl-spinner', `tl-spinner_${props.color}`]"
      :style="styles"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.0634 37.3074C46.2413 34.048 47.5827 30.3167 47.9877 26.4427C48.1316 25.0661 46.996 23.941 45.6119 23.941C44.2278 23.941 43.1231 25.069 42.9431 26.4414C41.7187 35.7789 33.7307 42.9877 24.059 42.9877C13.5398 42.9877 5.01231 34.4602 5.01231 23.941C5.01231 14.2693 12.2211 6.28128 21.5586 5.05688C22.931 4.87693 24.059 3.77219 24.059 2.38808C24.059 1.00397 22.9339 -0.131586 21.5573 0.012331C17.6833 0.417347 13.952 1.7587 10.6926 3.93661C6.73607 6.58025 3.65237 10.3378 1.8314 14.734C0.0104245 19.1302 -0.466025 23.9676 0.462298 28.6346C1.39062 33.3016 3.68202 37.5885 7.04674 40.9533C10.4115 44.318 14.6984 46.6094 19.3654 47.5377C24.0324 48.466 28.8698 47.9896 33.266 46.1686C37.6622 44.3476 41.4198 41.2639 44.0634 37.3074Z"
      />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  .tl-spinner {
    $root: &;

    animation: spin 1s linear infinite;
    fill: var(--color-brand-primary);

    &_secondary {
      fill: var(--color-brand-secondary);
    }

    &_tertiary {
      fill: var(--color-brand-tertiary);
    }

    &_text-primary {
      fill: var(--color-text-primary);
    }

    &_text-secondary {
      fill: var(--color-text-secondary);
    }

    &_text-tertiary {
      fill: var(--color-text-tertiary);
    }

    &_white {
      fill: var(--color-text-inverse-white);
    }

    &_black {
      fill: var(--color-text-inverse-black);
    }
  }
</style>
